export default "Secret Games åbnede i maj 2015.";